import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  ShareDropDownItemButton,
  type ShareDropDownItemButtonProps,
} from '~/components/features/ShareDropDownItemButton'
import { useCreateSharedUrl } from '~/hooks/useCreateSharedUrl'
import { useLogEvent } from '~/hooks/useLogEvent'

export type GetSharedUrlButtonProps = Pick<
  ShareDropDownItemButtonProps,
  'disabled'
> & {
  'data-testid'?: string
  restoringParams: unknown
}

export const GetSharedUrlButton = ({
  'data-testid': dataTestId = 'components-features-get-shared-url-button',
  disabled,
  restoringParams,
}: GetSharedUrlButtonProps) => {
  const { t } = useTranslation()
  const logEvent = useLogEvent()
  const createSharedUrl = useCreateSharedUrl()

  const handleClick = React.useCallback<
    EH<ShareDropDownItemButtonProps, 'onClick'>
  >(async () => {
    await createSharedUrl(restoringParams)

    logEvent('Generate shared URL', { withSuffix: true })
  }, [createSharedUrl, logEvent, restoringParams])

  return (
    <ShareDropDownItemButton
      data-testid={dataTestId}
      disabled={disabled}
      label={t('copy_link')}
      onClick={handleClick}
    />
  )
}
